import React from 'react';

export default function RevenueReportingTaxesDueLaterTooltip(props) {
	// console.log('RevenueReportingTaxesDueLaterTooltip', props);
	return (
		<div className="px-3 py-1 text-sm">
			<span>
				Based on your filing schedules, these are tax liabilities <br /> you'll
				owe at a later filing period.
			</span>
		</div>
	);
}
